import { HStack, Icon, Text, VStack } from '@chakra-ui/react';

import { Profile2UserOutline } from '@aslanpay/portal-common-lib';

import {
  PALETTE_COLORS,
  PALETTE_SIZES,
  PALETTE_SPACING,
  PALETTE_TRANSITIONS,
} from '../../constants';

import { EmployeeItemProps } from './EmployeeItem.types';

function EmployeeItem({
  employee,
  index,
  isSelected,
  onSelect,
  onClick,
  itemRef,
}: EmployeeItemProps) {
  const fullName = `${employee.firstName} ${employee.lastName}`.trim() || employee.email;

  return (
    <HStack
      role="button"
      tabIndex={0}
      ref={itemRef}
      p={PALETTE_SPACING.itemPadding}
      spacing={PALETTE_SPACING.itemSpacing}
      cursor="pointer"
      bg={isSelected ? PALETTE_COLORS.selectedBg : PALETTE_COLORS.transparent}
      _hover={{ bg: PALETTE_COLORS.selectedBg }}
      onClick={() => onClick(index)}
      onMouseEnter={() => onSelect(index)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          onClick(index);
        }
      }}
      borderLeft={
        isSelected
          ? `${PALETTE_SIZES.borderWidth} solid`
          : `${PALETTE_SIZES.borderWidth} solid transparent`
      }
      borderLeftColor={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.transparent}
      transition={PALETTE_TRANSITIONS.default}
    >
      <Icon
        as={Profile2UserOutline}
        boxSize={PALETTE_SIZES.iconSize}
        color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.textSecondary}
      />
      <VStack align="start" spacing="2px" flex={1}>
        <Text
          fontSize={PALETTE_SIZES.fontSize}
          fontWeight={isSelected ? '600' : '500'}
          color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.text}
        >
          {fullName}
        </Text>
        <Text fontSize={PALETTE_SIZES.fontSizeSmall} color={PALETTE_COLORS.textSecondary}>
          {employee.companyName ? `${employee.companyName} • ` : ''}
          {employee.email}
        </Text>
      </VStack>
    </HStack>
  );
}

export default EmployeeItem;
